const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserTracks', ['Application', 'Authorization', 'UserTracks', function (Application, Authorization, UserTracks) {
  return {
    restrict: 'E',
    scope: {
      user: '=',
      initKey: '=',
      initVal: '@',
      managerOverride: '@?',
      managerConfiguration: '=?'
    },
    replace: true,
    template: require('../../templates/directives/admin-user-tracks.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      self.employee = $scope.user;
      self.pages = [null];

      self.per_page = 10;
      self.page = 1;
      self.nextAvailable = true;

      if (self.user.role !== 'admin' && !$scope.managerOverride) {
        Application.navigation.goTo('/explore');
      }

      if ($scope.managerOverride && $scope.managerConfiguration) {
        if ($scope.managerConfiguration.disable_assignment_completion) {
          self.disableCompletion = true;
        }
        if ($scope.managerConfiguration.disable_assignment_removal) {
          self.disableRemoval = true;
        }
        if ($scope.managerConfiguration.disable_assignment_edit) {
          self.disableEdit = true;
        }
      }

      self.getProgress = function(amnt) {
        if (amnt !== 'unknown') {
          var style = {
            'width': amnt + '%'
          };
          return style;
        }
      };

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        }
      };

      self.parsePage = function(results) {
        var list = [];

        results.forEach(function(item) {
          if (!item.track || !item.track.name) {
            list.push({});
            return;
          }

          var started = moment(new Date(item.createdAt));
          var last = item.completed_date ? moment(new Date(item.completed_date)) : moment();

          var block = {
            _id: item._id,
            trackName: item.track.name,
            updated: item.updatedAt,
            started: item.createdAt,
            duration: last.diff(started, 'days') + ' days',
            completedDate: item.completed_date ? moment(item.completed_date).format('YYYY-MM-DD') : null
          };

          if (item.completed_date) {
            block.percentComplete = 100;
            block.percentStyle = self.getProgress(100);
            list.push(block);
            return;
          }

          var courses = [];
          var totalCourses = 0;
          var completed = [];
          var completedCount = 0;
          var previouslyCompleted = {};

          if (item.track && item.track.sections && item.track.sections.length) {
            item.track.sections.forEach(function(section) {
              if (!section || !section.courses || !section.courses.length) {
                return;
              }
              section.courses.forEach(function(course) {
                var id = course.assessment || course.article || course.media || course.file || course.video || course.scorm || course.quiz || null;
                if (!id) {
                  return;
                }
                courses.push(id);
              });
            });
          }

          totalCourses = courses.length;
          completed = completed.concat(item.completed_media || [], item.completed_articles || [], item.completed_assessments || [], item.completed_scorm || [], item.completed_quizzes || []);

          completed.forEach(function(course) {
            if (previouslyCompleted[course]) {
              return;
            }

            if (courses.indexOf(course) === -1) {
              return;
            }

            previouslyCompleted[course] = true;
            completedCount++;
          });

          var percent = (Math.round(completedCount / totalCourses * 100)) || 0;
          if (percent > 100) {
            percent = 100;
          }
          if (percent < 0) {
            percent = 0;
          }
          block.percentComplete = percent;
          block.percentStyle = self.getProgress(percent);

          list.push(block);
        });

        return list;
      };

      self.manualCompletion = {
        current: null,
        show: false,
        select: function(uTrack) {
          self.manualCompletion.current = uTrack;
          self.manualCompletion.show = true;
        },
        postSubmit: function() {
          self.getUserTracks();
        }
      };

      self.getUserTracks = function(views) {
        if (!self.employee) {
          return;
        }

        self.loading = true;

        var req = {
          user: self.employee,
          page: self.page || 1,
          per_page: self.per_page || 10,
          fields: 'user,track,completed_media,completed_articles,completed_quizzes,completed_scorm,completed_assessments,completed_date,updatedAt,createdAt',
          'track-populate': 'name,sections.courses',
          sort: 'updatedAt,-1'
        };

        UserTracks.find(req).$promise
        .then(function(results) {
          self.pages[self.page] = self.parsePage(results);
          self.currentPage = self.page;
          self.nextAvailable = true;
          if (results.length < self.per_page) {
            self.nextAvailable = false;
          }
          self.loading = false;
        });
      };

      self.changePage = function(next) {
        if (!next) {
          if (self.page > 1) {
            self.page = self.page - 1;
          }
          self.currentPage = self.page;
          self.nextAvailable = true;
          return;
        }

        self.nextAvailable = true;
        if (self.pages[self.page] && self.pages[self.page].length < self.per_page) {
          self.nextAvailable = false;
          return;
        }

        self.page = self.page + 1;

        if (self.pages[self.page]) {
          self.currentPage = self.page;
          return;
        }

        self.getUserTracks();
      };

      self.initialize = function() {
        self.getUserTracks();
      };

      if ($scope.initKey !== $scope.initVal) {
        var watchKey = $scope.$watch('initKey', function(newVal, oldVal) {
          if (newVal === $scope.initVal) {
            self.employee = $scope.user;
            self.initialize();
            watchKey();
          }
        });
        return;
      }

      self.initialize();
    }],
    controllerAs: 'userTracks'
  }
}]);